
import * as React from 'react';
import { withDropdownMenu } from 'ui';
import { SimpleFormValidationConfig, requiredValidation } from 'app/infrastructure/simple-form';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { form } from '../constants';
import { ConsentType } from '../types';
import { PushModal } from './push-modal';
import { EditConsentProps } from './types';

import styles from './edit-push-consent.scss';

interface EditPushConsentState {
  isOpen: boolean;
}
export class EditPushConsentComponent extends React.PureComponent<EditConsentProps, EditPushConsentState> {
  constructor(props: EditConsentProps) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  private handleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private onClose = () => {
    this.handleToggle();
    this.props.clearConsent();
    this.props.handleDropdownHide && this.props.handleDropdownHide();
  };

  private editConsent = () => {
    const {
      id,
      consent,
      saveSubscription,
      sharedState: { id: recipientId },
      serialize,
      validate,
      translation,
      loadConsents
    } = this.props;

    const serializedForm = serialize(defaultSerializeMappings);

    const subscription = {
      id,
      recipientId,
      type: ConsentType.push,
      value: {
        name: String(serializedForm.name),
        token: consent.value.token
      }
    };

    const validationConfig: SimpleFormValidationConfig = [
      requiredValidation(form.push.name)
    ];

    id && id > 0 && validate(validationConfig, () =>
      saveSubscription(id, subscription,
        () => {
          loadConsents();
          this.props.clearConsent();
        }), translation.validation_error);
  };

  private onDone = () => {
    const { checkConsent, consents, value, translation, id } = this.props;
    return checkConsent({ consents, onDone: this.editConsent, translation, value, id });
  };

  public render() {
    const {
      fetchingLoadConsent,
      fetchingSubscribePush,
      value
    } = this.props;

    return (<li className={styles.wrapper}>
      <button className="dropdown-item" onClick={this.handleToggle} disabled={fetchingLoadConsent}>
        {this.props.translation.edit}
      </button>
      {this.state.isOpen && <PushModal
        fetching={fetchingSubscribePush}
        value={value}
        onDone={this.onDone}
        onClose={this.onClose}
        {...this.props} />}
    </li>);
  }
}

const component = withDropdownMenu(EditPushConsentComponent);

export { component as EditPushConsent };
